import { FilterParams } from "@/_old/features/filters";

export enum BOOKING_TYPE {
  SHARED_SPACE = 1,
  PRIVATE_OFFICE = 6,
  EXCLUSIVE_OFFICE = 3,
  MEETING_ROOM = 4,
  EVENT_SPACE = 5,
}

export type BookingsResponse = {
  data: {
    data: {
      competency_type: "daily" | "monthly";
      usage: {
        competency: string;
        bookings_usage: {
          type: BOOKING_TYPE;
          credits_value: number;
          monetary_value: number;
        }[];
      }[];
    };
  };
};

export type Bookings = {
  sharedSpaces: number;
  exclusiveOffice: number;
  meetingRoom: number;
  privativeOffice: number;
  eventSpaces: number;
};

export type BookingsMonthly = {
  months: string[];
  competencyType: string;
  quantities: {
    sharedSpaces: number[];
    exclusiveOffice: number[];
    meetingRoom: number[];
    privativeOffice: number[];
    eventSpaces: number[];
  };
};

export type GetBookingsApi = (params: GetBookingsParams) => {
  bookings: Bookings;
  bookingsMonthly: BookingsMonthly;
};

export type GetBookingsParams = FilterParams;
